"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _vuex = require("vuex");

var _index = require("@/api/ad/index");

var _index2 = require("@/api/goods/index");

var _FooterTabbar = _interopRequireDefault(require("@/components/FooterTabbar"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// createNamespacedHelpers
var _default = {
  name: 'home',
  data: function data() {
    return {
      currentBannerIndex: 0,
      banner: '',
      goods: '',
      keywords: ''
    };
  },
  components: {
    FooterTabbar: _FooterTabbar.default
  },
  computed: {},
  methods: {
    onSearch: function onSearch() {},
    onCancel: function onCancel() {},
    onChange: function onChange(index) {
      this.currentBannerIndex = index;
    },
    bannerClick: function bannerClick() {
      var url = this.banner.ads[this.currentBannerIndex].url; // 跳转到商品详情页面并且传值

      this.$router.push({
        path: url
      });
    },
    goToGoodsDetail: function goToGoodsDetail(goods) {
      // 跳转到商品详情页面并且传值
      this.$router.push({
        path: "/goods/".concat(goods.id)
      });
    },
    initData: function () {
      var _initData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _index.getAdList)().then(function (res) {
                  _this.banner = res.data;
                });

              case 2:
                _context.next = 4;
                return (0, _index2.getGoodsList)().then(function (res) {
                  _this.goods = res.data;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  },
  created: function created() {
    this.initData();
  }
};
exports.default = _default;